<script setup lang="ts">
// 應用根元件：只負責掛載路由出口，版面一律由各路由的 layout 負責
</script>

<template>
  <!--
    key 用 fullPath：切換門店或深連結參數變動時強制重建 view，
    避免 setup 只跑一次而讓上一間店的狀態殘留在元件裡。
    Suspense 承接 view 內的頂層 await（如路由層級的資料預取）；
    fallback 刻意留空 —— 骨架屏由各 view 自己畫，根層畫會造成整頁閃爍。
  -->
  <RouterView v-slot="{ Component, route }">
    <Suspense>
      <!--
        ★ key 用 `route.path`，**不可以**用 `fullPath`。
          fullPath 包含 query string，而報表頁將分頁放在 `?tab=`
          （`ReportsView.vue` 的 activeTab）—— 用 fullPath 的話一按分頁
          key 就改變，Vue 會拆掉整個 view 重建，使用者選好的日期範圍立即彈回預設。
          2026-09-03 由 802 報表揪出：「切換報表時查詢日期會變」。
        ⚠️ 依靠 query 變化來重載的 view 要自行 watch `route.query`，不可以再依靠 remount。
      -->
      <component :is="Component" :key="route.path" />
      <template #fallback><div class="sr-only">載入中…</div></template>
    </Suspense>
  </RouterView>
</template>
